import { addDiamondsBody } from "pages/Diamond/Products/AddDiamonds";
import { APIClient } from "./api_helper";

import * as url from "./url_helper";
import { updateInventoryPayloadType } from "pages/Diamond/Inventory/AllInventories";
import {
  addCategoryBodyType,
  addMetalBodyType,
  addStyleBodyType,
  addSubCategoryBodyType,
  updateCategoryBodyType,
  updateDiscountBodyType,
  updateJewelleryMetalBodyType,
  updateStyleBodyType,
  updateSubCategoryBodyType,
} from "slices/jewellery/thunk";

const api = new APIClient();

// Inventory

export const getAllInventories = () => api.get(url.GET_ALL_INVENTORIES, {});
export const updateInventory = (body: updateInventoryPayloadType) =>
  api.put(url.UPDATE_INVENTORY, body);
export const deleteInventory = (id: string) =>
  api.delete(url.DELETE_INVENTORY, {
    params: {
      id,
    },
  });

// Diamonds

export const getDiamond = (id: string) => api.get(url.GET_DIAMOND, { id });
export const getDiamondByStockId = (stockId: string) =>
  api.get(`${url.GET_DIAMOND_BY_STOCK_ID}/${stockId}`, null);
export const getDiamonds = (body: any) => api.post(url.GET_DIAMONDS, body);

export const addDiamonds = (body: addDiamondsBody) =>
  api.post(url.ADD_DIAMONDS, body);

// Users

export const registerUser = (body: any) => api.create(url.REGISTER_USER, body);
export const loginUser = (body: any) => api.post(url.LOGIN_USER, body);
export const getUsersByRole = (role: string) =>
  api.get(url.GET_USERS_BY_ROLE, { role });
export const getUserByEmail = (email: string) => api.get(`${url.GET_USER_BY_EMAIL}/${email}`, null)
export const createUser = (body: any) => api.post(url.CREATE_USER, body);

//Forgot Password 

export const forgotPassword = (body: any) =>
  api.post(url.POST_FORGOT_PASSWORD, body);
export const verifyOTP = (body: any) => api.post(url.POST_VERIFY_OTP, body);
export const updatePassword = (body: any) =>
  api.post(url.POST_UPDATE_PASSWORD, body);

// Suppliers
export const addSupplier = (data: any) => api.create(url.ADD_SUPPLIER, data);

// Orders

export const addOrder = (body: any) => api.post(url.ADD_ORDER, body);
export const getOrders = (type: any) =>
  api.get(url.GET_ORDERS_BY_TYPE, { type });
export const updateOrder = (body: any) => api.put(url.UPDATE_ORDER, body);
export const deleteOrder = (id: string) =>
  api.delete(`${url.DELETE_ORDER}?id=${id}`, {});
export const getOrderById = (id: string) =>
  api.get(`${url.GET_ORDER_BY_ID}/${id}`, null);

// Category

export const addCategory = (body: addCategoryBodyType) =>
  api.create(url.ADD_CATEGORY, body);
export const getCategories = () => api.get(url.GET_CATEGORY, null);
export const updateCategory = (body: updateCategoryBodyType) =>
  api.put(url.UPDATE_CATEGORY, body);
export const deleteCategory = (id: string) =>
  api.delete(`${url.DELETE_CATEGORY}/${id}`, null);

// Sub Category

export const addSubCategory = (body: addSubCategoryBodyType) =>
  api.create(url.ADD_SUB_CATEGORY, body);
export const getSubCategories = () => api.get(url.GET_SUB_CATEGORY, null);
export const updateSubCategory = (body: updateSubCategoryBodyType) =>
  api.put(url.UPDATE_SUB_CATEGORY, body);
export const deleteSubCategory = (id: string) =>
  api.delete(`${url.DELETE_SUB_CATEGORY}/${id}`, null);

// Style

export const addStyle = (body: addStyleBodyType) =>
  api.create(url.ADD_STYLE, body);
export const getStyles = () => api.get(url.GET_STYLES, null);
export const updateStyle = (body: updateStyleBodyType) =>
  api.put(url.UPDATE_STYLE, body);
export const deleteStyle = (id: string) =>
  api.delete(`${url.DELETE_STYLE}/${id}`, null);

// Shape

export const addShape = (body: any) => api.create(url.ADD_SHAPE, body);
export const getShapes = () => api.get(url.GET_SHAPES, null);
export const updateShape = (body: any) => api.put(url.UPDATE_SHAPE, body);
export const deleteShape = (id: string) =>
  api.delete(`${url.DELETE_SHAPE}/${id}`, null);

// Jewellery

export const addJewellery = (body: any) => api.create(url.ADD_JEWELLERY, body);
export const getJewelleryById = (id: string) =>
  api.get(`${url.GET_JEWELLERY_BY_ID}/${id}`, null);
export const getJewelleryBySlug = (slug: string) =>
  api.get(`${url.GET_JEWELLERY_BY_SLUG}/${slug}`, null);
export const getJewelleryBySku = (sku: string) =>
  api.get(`${url.GET_JEWELLERY_BY_SKU}/${sku}`, null);
export const getJewelleries = (body: any) =>
  api.post(url.GET_JEWELLERIES, body);
export const updateJewellery = (body: any) =>
  api.put(url.UPDATE_JEWELLERY, body);
export const deleteJewellery = (id: string) =>
  api.delete(`${url.DELETE_JEWELLERY}/${id}`, null);

// Jewellery Metal

export const addJewelleryMetal = (body: addMetalBodyType) =>
  api.create(url.ADD_JEWELLERY_METAL, body);
export const getJewelleryMetals = () => api.get(url.GET_JEWELLERY_METALS, null);
export const updateJewelleryMetal = (body: updateJewelleryMetalBodyType) =>
  api.put(url.UPDATE_JEWELLERY_METAL, body);
export const deleteJewelleryMetal = (id: string) =>
  api.delete(`${url.DELETE_JEWELLERY_METAL}/${id}`, null);

// Jewellery Discount

export const addJewelleryDiscount = (body: any) =>
  api.post(url.ADD_JEWELLERY_DISCOUNT, body);
export const getJewelleryDiscounts = (body: any) =>
  api.get(url.GET_JEWELLERY_DISCOUNT, body);
export const updateJewelleryDiscount = (body: any) =>
  api.put(url.UPDATE_JEWELLERY_DISCOUNT, body);

// Diamond Prices

export const addDiamondPrices = (body: any) =>
  api.create(url.ADD_DIAMOND_PRICES, body);
export const getDiamondPrices = () => api.get(url.GET_DIAMOND_PRICES, null);
export const countDiamondPrices = (body: any) => {
  return api.post(url.COUNT_DIAMOND_PRICES, body);
};
export const getCenterDiamondPrices = (carat: number[]) =>
  api.get(`${url.CENTER_DIAMOND_PRICES}?carats=${carat}`, null);

//blog

export const createBlogApi = (body: any) => api.post(url.CREATE_BLOG, body);
export const getBlogsApi = (body: any) => api.get(url.GET_BLOGS, body);
export const getBlogByIdApi = (id: string) =>
  api.get(`${url.GET_BLOG_BY_ID}/${id}`, null);
export const updateBlogApi = (id: string, body: any) =>
  api.put(`${url.UPDATE_BLOG}/${id}`, body);
export const deleteBlogApi = (id: string) =>
  api.delete(`${url.DELETE_BLOG}/${id}`, null);

//address

export const addAddress = (body: any) => api.post(url.ADD_ADDRESS, body);